@if (!canPreview) {
    <nz-alert nzType="info" nzMessage="Šim formātam priekšskats nav pieejams. Izmantojiet esošo lejupielādes iespēju."></nz-alert>
}
@for (error of fileErrors; track $index) {
    <nz-alert nzType="error" nzShowIcon [nzMessage]="error"></nz-alert>
}
@if (previewLoading) {
    <nz-spin nzSimple></nz-spin>
    <p>Ielādē priekšskatu…</p>
}
@if (previewUrl || imageUrl) {
    <p>
        <strong>{{ fileName }}</strong>
    </p>
}
@if (previewUrl) {
    <iframe class="document-preview" title="Dokumenta priekšskats" [src]="previewUrl"></iframe>
}
@if (imageUrl) {
    <img class="document-image" [src]="imageUrl" [alt]="fileName" (error)="imageFailed($event)" />
}
